import $x from '../utils/$x';

const BASE_PATH = '/actionConfig/manage';

function post(path, requestData = {}, page) {
  const payload = { requestData };
  if (page) payload.page = page;
  return $x.post(`${BASE_PATH}${path}`, payload);
}

function parseIdentifierList(value) {
  return (value || '')
    .split(/[\n,]/)
    .map((item) => item.trim())
    .filter(Boolean);
}

/**
 * 将页面发布模式转换为配置中心识别的灰度请求。
 * 定向模式必须使用 0 基点，否则服务端会按比例灰度处理。
 */
export function buildActionConfigRolloutRequest(actionId, values = {}) {
  const constrained = values.mode !== 'full';
  const percentageBps =
    values.mode === 'full'
      ? 10000
      : values.mode === 'targeted'
      ? 0
      : values.percentageBps || 0;

  return {
    actionId: Number(actionId),
    configReleaseId: values.configReleaseId,
    percentageBps,
    executionKeyWhitelist: constrained
      ? parseIdentifierList(values.executionKeys)
      : [],
    memberIdWhitelist: constrained ? parseIdentifierList(values.memberIds) : [],
    platforms: constrained ? values.platforms || [] : [],
    minClientVersion: constrained ? values.minClientVersion : undefined,
    minCoreVersion: constrained ? values.minCoreVersion : undefined,
    priority: values.priority || 0,
    remark: values.remark,
  };
}

export function queryActionConfigPage(requestData, page) {
  return post('/page', requestData, page);
}

export function queryActionConfigDetail(actionId) {
  return post('/detail', { actionId });
}

export function queryValidationDetail(validationReportId) {
  return post('/validation/detail', { validationReportId });
}

export function queryReleasePage(actionId, page) {
  return post('/release/page', { actionId }, page);
}

export function queryRolloutPage(actionId, page) {
  return post('/rollout/page', { actionId }, page);
}

export function queryDraftRevisionPage(actionId, page) {
  return post('/draft/revision/page', { actionId }, page);
}

export function queryAuditPage(actionId, page) {
  return post('/audit/page', { actionId }, page);
}

export function compareActionConfig(requestData) {
  return post('/compare', requestData);
}

export function queryActionConfigPermissions() {
  return post('/permissions');
}

/** 查询 AI 生成与人工可视化编排共用的受约束组件注册表。 */
export function queryMotionConfigWorkbenchContext() {
  return post('/workbench/context');
}

/** 生成受共同能力注册表约束的配置候选；服务端不会自动保存草稿。 */
export function generateMotionActionConfigCandidate(requestData) {
  return post('/candidate/generate', requestData);
}

export function saveActionConfigDraft(requestData) {
  return post('/draft/save', requestData);
}

export function validateActionConfigDraft(requestData) {
  return post('/draft/validate', requestData);
}

export function publishActionConfigRelease(requestData) {
  return post('/release/publish', requestData);
}

export function startActionConfigRollout(requestData) {
  return post('/rollout/start', requestData);
}

export function adjustActionConfigRollout(requestData) {
  return post('/rollout/adjust', requestData);
}

export function pauseActionConfigRollout(requestData) {
  return post('/rollout/pause', requestData);
}

export function rollbackActionConfigRelease(requestData) {
  return post('/rollback', requestData);
}
